import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=ec96822a&scoped=true"
import script from "./BookingList.vue?vue&type=script&lang=js"
export * from "./BookingList.vue?vue&type=script&lang=js"
import style0 from "./BookingList.vue?vue&type=style&index=0&id=ec96822a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec96822a",
  null
  
)

export default component.exports